import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import IconClose from '../ui/icons/IconClose';
/*
	SearchModal - used on search filters for mobile and map view
	@props
		isShown - boolean - whether or not the modal is shown
		onClose - function - callback to close the modal
		headerText - string - text to display in the modal header
		children - ReactNode - content to display in the modal body
*/
const SearchModal = ( props ) => {
	const { isShown, onClose, headerText, children } = props;
	return (
		<Transition
			show={isShown}
			as={Fragment}
			unmount={false}
		>
			<Dialog unmount={false} onClose={() => onClose()} className="tw-relative tw-z-[1000]">
				{/* Backdrop */}
				<Transition.Child
					as={Fragment}
					enter="tw-ease-out tw-duration-200"
					enterFrom="tw-opacity-0"
					enterTo="tw-opacity-100"
					leave="tw-ease-in duration-100"
					leaveFrom="tw-opacity-100"
					leaveTo="tw-opacity-0"
					unmount={false}
				>
					<div className="tw-fixed tw-inset-0 tw-bg-steel/80" aria-hidden="true" />
				</Transition.Child>
				<Transition.Child
					as={Fragment}
					enter="tw-ease-out tw-duration-200"
					enterFrom="tw-opacity-0 tw-scale-95"
					enterTo="tw-opacity-100 tw-scale-100"
					leave="tw-ease-in tw-duration-150"
					leaveFrom="tw-opacity-100"
					leaveTo="tw-opacity-0"
					unmount={false}
				>
					<div className="tw-fixed tw-top-5 tw-inset-0 tw-overflow-y-auto">
						<Dialog.Panel className={`tw-rounded-lg tw-bg-white tw-w-full tw-pt-5`}>
							<Dialog.Title className={`tw-relative tw-text-center tw-border-b tw-border-platinum tw-text-lg tw-pb-2 tw-m-0`}>
								<button type="button" onClick={() => onClose()} className={`tw-bg-transparent tw-absolute -tw-top-2 tw-left-3 tw-p-2`}>
									<IconClose />
								</button>
								{headerText}
							</Dialog.Title>
							<div>
								{children}
							</div>
						</Dialog.Panel>
					</div>
				</Transition.Child>
			</Dialog>
		</Transition>
	);
};

export default SearchModal;
